import { Plans } from 'lib/types';
import { CheckmarkIcon } from './checkmark';
import { CreateTeamIcon } from './createTeam';
import { EnvelopeIcon } from './envelope';
import { LinkIcon } from './link';
import { DocIcon } from "./doc"
import { EpsIcon } from "./eps"
import { HtmlIcon } from "./html"
import { IllustratorIcon } from "./illustrator"
import { ImageIcon } from "./image"
import { PdfIcon } from "./pdf"
import { PhotoshopIcon } from "./photoshop"
import { PptIcon } from "./ppt"
import { SlidedeckIcon } from "./slidedeck"
import { SpreadsheetIcon } from "./spreadsheet"
import { TxtIcon } from "./txt"
import { VideoIcon } from "./video"
import { ZipIcon } from "./zip"
import { FileIcon } from "./file"
import { AudioIcon } from "./audio"
import { PadlockIcon } from './padlock';
import { PersonIcon } from './person';
import { PlanIndividualIcon } from './planIndividual';
import { PlanTeamIcon } from './planTeam';
import { VisiblityShow } from './visibilityShow';


export { InfinityIcon } from './infinity';
export { HandleIcon } from './handle';
export { WavingHand } from './wavingHand';
export { SuperPacksIcon } from './superPacks';

export enum BaseIcons {
  Envelope = 'Envelope',
  Padlock = 'Padlock',
  VisiblityShow = 'VisiblityShow',
  Checkmark = 'Checkmark',
  Person = 'Person',
  Link = 'Link',
  Doc = 'Doc',
  Eps = 'Eps',
  Html = 'Html',
  Illustrator = 'Illustrator',
  Image = 'Image',
  Pdf = 'Pdf',
  Photoshop = 'Photoshop',
  Ppt = 'Ppt',
  Slidedeck = 'Slidedeck',
  Spreadsheet = 'Spreadsheet',
  Txt = 'Txt',
  Video = 'Video',
  Zip = 'Zip',
  File = 'File',
  Audio = 'Audio',
}

export type Icons = Plans & BaseIcons;
export type KeyOfIcons = keyof typeof Plans | keyof typeof BaseIcons;

export const getIconComponent = (name: KeyOfIcons) => {
  switch (name) {
    case BaseIcons.Padlock:
      return PadlockIcon;
    case BaseIcons.Envelope:
      return EnvelopeIcon
    case BaseIcons.VisiblityShow:
      return VisiblityShow
    case BaseIcons.Checkmark:
      return CheckmarkIcon
    case BaseIcons.Link:
      return LinkIcon
    case BaseIcons.Doc:
      return DocIcon
    case BaseIcons.Eps:
        return EpsIcon
    case BaseIcons.Html:
      return HtmlIcon
    case BaseIcons.Illustrator:
      return IllustratorIcon
    case BaseIcons.Image:
      return ImageIcon
    case BaseIcons.Pdf:
      return PdfIcon
    case BaseIcons.Photoshop:
      return PhotoshopIcon
    case BaseIcons.Ppt:
      return PptIcon
    case BaseIcons.Slidedeck:
      return SlidedeckIcon
    case BaseIcons.Spreadsheet:
      return SpreadsheetIcon
    case BaseIcons.Txt:
      return TxtIcon
    case BaseIcons.Video:
      return VideoIcon
    case BaseIcons.Zip:
      return ZipIcon
    case BaseIcons.File:
      return FileIcon
    case BaseIcons.Audio:
      return AudioIcon
    case BaseIcons.Person:
      return PersonIcon
    case Plans.Individual:
      return PlanIndividualIcon
    case Plans.JoinTeam:
      return PlanTeamIcon
    case Plans.CreateTeam:
      return CreateTeamIcon
    default:
      return null;
  }
}

export const getIcon = (name: KeyOfIcons) => {
  const Component = getIconComponent(name);
  return <Component />;
}
